import React from "react";
import "./MainFooter.css";
import styled from "styled-components";
const FooterBottom = styled.div`
  background: #ff6699;
  color: white;
  padding: 10px;
  text-align: center;
  margin-top: 0px;
  font-size: 12px;
`;
export default function MainFooter() {
  return (
    <div style={{ marginTop: "100px" }}>
      <FooterBottom>© 2025 ReciteOnTV. All rights reserved.</FooterBottom>
    </div>
  );
}
